export default __webpack_public_path__ + "static/media/getStartElement.319df199.svg";